export const STATUS = {
  REGISTRATION_REQUESTED: 'REGISTRATION_REQUESTED',
  DATA_VALIDATION: 'DATA_VALIDATION',
  EMISSION_PORTAL_REGISTRATION: 'EMISSION_PORTAL_REGISTRATION',
  REGISTRATION_RELEASE: 'REGISTRATION_RELEASE',
  CTE_EMISSION: 'CTE_EMISSION',
  REJECTED: 'REJECTED',
  RETURN_FROM_REJECTION: 'RETURN_FROM_REJECTION',
};

// A esteira linear do cadastro; reprovado e retorno de reprovação ficam fora dela.
export const LINEAR_STEPS = [
  STATUS.REGISTRATION_REQUESTED,
  STATUS.DATA_VALIDATION,
  STATUS.EMISSION_PORTAL_REGISTRATION,
  STATUS.REGISTRATION_RELEASE,
  STATUS.CTE_EMISSION,
];

export const STATUS_ORDER = [...LINEAR_STEPS, STATUS.REJECTED, STATUS.RETURN_FROM_REJECTION];

// Status em que a tela de detalhe monta o formulário de dados. RETURN_FROM_REJECTION entra aqui
// porque a aprovação desse status exige o payload completo, igual à análise documental.
const EDITABLE_STATUSES = [
  STATUS.REGISTRATION_REQUESTED,
  STATUS.DATA_VALIDATION,
  STATUS.RETURN_FROM_REJECTION,
];

export function isEditableStatus(slug) {
  return EDITABLE_STATUSES.includes(slug);
}

export const STATUS_NAMES = {
  [STATUS.REGISTRATION_REQUESTED]: 'Solicitou Cadastro',
  [STATUS.DATA_VALIDATION]: 'Análise Documental',
  [STATUS.EMISSION_PORTAL_REGISTRATION]: 'Em Cadastro Transportador Sistema Emissão',
  [STATUS.REGISTRATION_RELEASE]: 'Cadastro para Emissão Contra CT-e',
  [STATUS.CTE_EMISSION]: 'Emitindo Contra CT-e',
  [STATUS.REJECTED]: 'Cadastro Reprovado',
  [STATUS.RETURN_FROM_REJECTION]: 'Retorno de reprovação',
};

export const STATUS_COLORS = {
  [STATUS.REGISTRATION_REQUESTED]: '#6b7f92',
  [STATUS.DATA_VALIDATION]: '#c98a1e',
  [STATUS.EMISSION_PORTAL_REGISTRATION]: '#1c6fb8',
  [STATUS.REGISTRATION_RELEASE]: '#6b7f92',
  [STATUS.CTE_EMISSION]: '#1f8a5b',
  [STATUS.REJECTED]: '#b4392f',
  [STATUS.RETURN_FROM_REJECTION]: '#8a5bd6',
};

export const DEFAULT_STATUS_COLOR = '#6b7f92';

export const NOT_INFORMED = 'Não informado';

export function getStatusName(status) {
  return status?.name || STATUS_NAMES[status?.slug] || '-';
}

export function getStatusColor(slug) {
  return STATUS_COLORS[slug] || DEFAULT_STATUS_COLOR;
}

export function getAvailableActions(slug) {
  switch (slug) {
    case STATUS.REGISTRATION_REQUESTED:
      return ['startAnalysis', 'reject'];
    case STATUS.DATA_VALIDATION:
    // Reavaliação de uma solicitação reenviada: mesmas ações da análise documental (RN-007).
    case STATUS.RETURN_FROM_REJECTION:
      return ['approveData', 'reject'];
    case STATUS.EMISSION_PORTAL_REGISTRATION:
      return ['approveEmission'];
    case STATUS.REJECTED:
      return ['reopen'];
    default:
      return [];
  }
}

// Permissão exigida por ação (US12, RN-015). `approveData` e `approveEmission` batem na mesma rota
// `POST /:id/approve`, e `reopen` acompanha `reject` no `POST /:id/reopen` — por isso compartilham o slug.
// Só o mapa mora aqui: quem lê a permissão do usuário é o hook `useAllowedActions`.
export const ACTION_PERMISSIONS = {
  startAnalysis: 'ANALISAR_TRANSPORTADORAS_SOLICITACOES',
  approveData: 'APROVAR_TRANSPORTADORAS_SOLICITACOES',
  approveEmission: 'APROVAR_TRANSPORTADORAS_SOLICITACOES',
  reject: 'REPROVAR_TRANSPORTADORAS_SOLICITACOES',
  reopen: 'REPROVAR_TRANSPORTADORAS_SOLICITACOES',
};

export function normalizeCounts(counts) {
  const bySlug = {};
  (Array.isArray(counts) ? counts : []).forEach((item) => {
    if (item?.slug) bySlug[item.slug] = item;
  });

  return STATUS_ORDER.map((slug) => ({
    slug,
    name: bySlug[slug]?.name || STATUS_NAMES[slug],
    total: Number(bySlug[slug]?.total) || 0,
  }));
}

// Data sem hora (YYYY-MM-DD): formatada por texto para não deslocar o dia no fuso de Brasília.
export function formatDateOnly(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
  if (!match) return NOT_INFORMED;
  const [, year, month, day] = match;
  return `${day}/${month}/${year}`;
}

const dateTimeFormatter = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeStyle: 'short',
  timeZone: 'America/Sao_Paulo',
});

export function formatDateTime(value) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return dateTimeFormatter.format(date);
}
